<template>
  <div id="chargeRecord">
    <el-row style="height: 3rem">
      <el-col :span="12">
        <el-row>
          <el-col :span="10">制表人：</el-col>
          <el-col :span="14">{{ chargeData.createByName }}</el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row>
          <el-col :span="10">制表时间：</el-col>
          <el-col :span="14">{{ chargeData.createTime }}</el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row style="height: 3rem">
      <el-col :span="12">
        <el-row>
          <el-col :span="10">开始时间：</el-col>
          <el-col :span="14">{{ chargeData.start_time }}</el-col>
        </el-row>
      </el-col>
      <el-col :span="12">
        <el-row>
          <el-col :span="10">结束时间：</el-col>
          <el-col :span="14">{{ chargeData.end_time }}</el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row style="height: 3rem">
      <el-col :span="12">
        <el-row>
          <el-col :span="10">充值金额(元)：</el-col>
          <el-col :span="14">{{ chargeData.recharge_money }}</el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row style="height: 3rem">
      <el-col>
        <el-row>
          <el-col :span="5">备注：</el-col>
          <el-col :span="19" >{{ chargeData.remark }}</el-col>
        </el-row>
      </el-col>
    </el-row>
    <hr />
  </div>
</template>

<script>
export default {
  props: ["chargeData"],
  data() {
    return {};
  },
};
</script>
